import { render, staticRenderFns } from "./RevisarEvaluacionSalle.vue?vue&type=template&id=e47ac5ac"
import script from "./RevisarEvaluacionSalle.vue?vue&type=script&lang=js"
export * from "./RevisarEvaluacionSalle.vue?vue&type=script&lang=js"
import style0 from "./RevisarEvaluacionSalle.vue?vue&type=style&index=0&id=e47ac5ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports